import React from "react";
import BlogCard from "./BlogCard";

const blogData = [
  {
    id: 1,
    title: "Как я стал программистом",
    image: "https://habrastorage.org/getpro/habr/post_images/3db/ac4/5df/3dbac45df51c33b0bd63621081afbe29.jpg",
    date: "2025-04-05",
    category: "История",
    fullText: `Всё началось со старого ноутбука и интереса к играм. Я хотел понять, как работают читы, и начал изучать код. Со временем увлёкся программированием всерьёз.

Чтобы прокачать навыки, я пошёл учиться в IT STEP Academy. Там я получил базу, научился писать настоящие программы и понял, что хочу связать с этим свою жизнь.

Теперь я программист и продолжаю развиваться в любимом деле.`,
  },
  {
    id: 2,
    title: "10 трюков в JavaScript, которые сделают вас мастером",
    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%253D%253D&auto=format&fit=crop&w=1000&q=80",
    date: "2025-04-06",
    category: "Программирование",
    fullText:
    `10 СКРЫТЫХ ВОЗМОЖНОСТЕЙ JAVASCRIPT
==================================

JavaScript — язык с множеством «подводных камней». Вот 10 трюков, которые расширят ваши навыки:

――――――――――――――――――――――――――――――――――――
1. ДЕСТРУКТУРИЗАЦИЯ С ПЕРЕИМЕНОВАНИЕМ
Пример:
const user = { id: 1, name: 'Alex' };
const { name: userName } = user;
// Результат: userName = 'Alex'

――――――――――――――――――――――――――――――――――――
2. ОПЕРАТОР НУЛЕВОГО СЛИЯНИЯ (??)
Пример:
const role = user.role ?? 'guest';
// Если user.role равен null/undefined,
// то role = 'guest'

――――――――――――――――――――――――――――――――――――
3. МЕТОД .at() ДЛЯ МАССИВОВ
Пример:
const arr = [1, 2, 3];
arr.at(-1);
// Результат: 3 (последний элемент)

――――――――――――――――――――――――――――――――――――
ДРУГИЕ ПРИЁМЫ:
• Динамические импорты модулей
• Private-поля в классах (#secretField)
• Оптимизация через Web Workers

――――――――――――――――――――――――――――――――――――
"Эти трюки — как секретное оружие JS-разработчика"

Какой приём вам понравился больше всего?
Напишите в комментариях!`,
  },
];

const Blog = () => {
  return (
    <div className="grid md:grid-cols-2 gap-8 p-4">
      {blogData.map((blog) => (
        <BlogCard key={blog.id} {...blog} />
      ))}
    </div>
  );
};

export default Blog;
